import React, { Component } from 'react';
import _, { isEmpty, get } from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';

import asyncRoute from '../../../helpers/hoc/asyncRoute';
import routes from '../../../routes';
import BinarySelect from '../../../components/BinarySelect'
import MultiSelect from '../../../components/FormElements/MultiSelect'

import Input from '../../../components/FormElements/Input';
// import File from '../../../../../components/FormElements/File';
import Textarea from '../../../components/FormElements/Textarea';
import Select from '../../../components/FormElements/Select';
import DatePicker from '../../../components/Datepicker'
import ModalConfirmation from '../../../components/ModalConfirmation';
// import MultiSelect from '../../../components/FormElements/MultiSelect';
import TimePicker from '../../../components/FormElements/TimePicker';
import { handleFieldError, initializeForm, handleError } from '../../../utils/form-validation';
import { formFields, confirmationMessage, successfullyMessage, platformtype, dvPlatform, IONplatform, Goal, roStaus } from './constant';
// import { bidderReport } from '../Io/constant';
import { addIoReportAction, getIoAdvertisersReportAction, getIoEditIdReportAction, getCategoryAction, getSUbCategoryAction, getPrimaryGoalAction, getSecondaryGoalAction, updateRoAction, uploadFileAction, getUnmappedCampaignListAction, roListNamesAction, createMapRoAction } from '../../../actions';
import { sortArray } from '../../../selectors';
import CheckboxGroup from '../../../components/FormElements/CheckboxGroup';
import RadioGroup from '../../../components/FormElements/RadioGroup'
import { log } from 'async';
import "../ro.scss"
import { imageUrl } from "../../../constants/configuration";
import ToastModal from "../../../components/ToastModal";
// import BinarySelect from '../../../components/BinarySelect'

const Card = asyncRoute(() => import('../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../components/BreadCrumb'));

class AddRo extends Component {
  constructor(props) {
    super(props);
    this.fileRef = React.createRef();
    this.state = {
      roForm: {
        edate: moment(Date.now()).add(90, 'days').toDate(),
        sdate: new Date(),
      },
      form: {},
      touched: {},
      errors: {},
      editMode: false,
      submited: false,
      confirmationOpen: false,
      confirmationInfo: '',
      categoryData: [],
      primaryGoalData: [],
      secondaryGoalData: [],
      googleAds: [{ masterAccountID: "", goggleAdvertiserID: "", currency: "" }],
      facebookAds: [{ fbAccountID: "", fbCurrency: "" }],
      dv360Ads: [{ dv360AccountID: "", dv360Currency: "" }],
      ionAds: [{ ionAccountID: "", ionCurrency: "" }],
      platformCheck: [],
      platforms: [],
      googleCheck: [],
      facebookCheck: [],
      dv360Check: [],
      ionDataCheck: [],
      advertiserCreate: {
        advertisersPlatforms: [],
      },
      primaryGoalId: null,
      secondaryGoalId: null,
      mappedCampaigns: [],
      creativeUrl: '',
      unmappedDataList: [],
      roListNames: [],
      toastStatus: "",
      toastMsg: "",
      enableToast: "",
      confirmationMsg: ""
    };
  }

  async componentWillMount() {
    const { match: { params: { id } }, tenantId, authToken, userId, getIoAdvertisersReportAction, configurationList, getUnmappedCampaignListAction, advertiserList } = this.props;

    const currency = get(configurationList.find(currency => currency.attrName === 'CURRENCY'), 'attributeValues', []);
    let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
    if (isEmpty(isAuthenticated)) {
      const { history } = this.props;
      history.push(routes.preSignIn);
    }
    const { form, errors } = initializeForm(formFields);
    let curreValue = currency.find(a => a.value == "USD");
    if (curreValue) {
      form.currency = curreValue.key;
    }
    form.startDate = moment().toDate();

    this.setState({ form, errors })
    // form.advertiserId = tenantId;  
    await this.fetchCreateRO();

    getIoAdvertisersReportAction(tenantId, authToken, userId);
    await this.categoryApiFunction();
    await this.primaryGoalApiFunction();

      var filteredAdvertiser = advertiserList.filter(adv => adv.tenantId === tenantId);
      var advertiserFilter = filteredAdvertiser.map(item => { return { key: item.tenantId, value: item.tenantName } })
      if (advertiserFilter.length == 1) {
       
        this.setState(prevState => ({
          advertiserFilter:advertiserFilter,
          form: {
            ...prevState.form,
            advertiserId: advertiserFilter[0].key,
          },
        }));
      }


      this.setState(prevState => ({
        form: {
          ...prevState.form,
          status:1
        },
      }));
  }

  fetchCreateRO = async () => {
    const { getUnmappedCampaignListAction, tenantId, authToken, userId, match: { params: { id } },history } = this.props
    const { form } = this.state;
    const idArr = JSON.parse(localStorage.getItem("unmappedIdArr"));

    const {
      responseCode: { status = "" },
      responseList,
    } = await getUnmappedCampaignListAction({ tenantId, authToken, userId });
    if (status == "Success") {
      const data = responseList;

      data.forEach(e => {
        if (e.url === undefined) {
          Object.assign(e, { url: '' })
        }
      })

      // ============ split ',' from params =========

      if (idArr.length > 0) {
        const filteredIds = data.filter(item => idArr.includes(item.campaignId));
        if(filteredIds.length > 0){
          this.setState({ unmappedDataList: filteredIds });
          }
          else{
            history.push('/' + routes.mainRoute + '/' + routes.containers.unmappedCampaign);
          }

      } else {
        const findMappedData = data.filter(item => item.campaignId == idArr);
        if(findMappedData.length > 0){
          this.setState({ unmappedDataList: findMappedData });
        }
        else{
          history.push('/' + routes.mainRoute + '/' + routes.containers.unmappedCampaign);
        }
      }
    }

  }

  handleChange = (e) => {
    let { form, categoryData, primaryGoalData, secondaryGoalData, subCategoryData } = this.state;
    let { value, name } = e.target;
    form[name] = value;
    this.setState({ form }, () => {

      // if (name === "campaigncategory") {
      //   const categoryValue = value;
      //   const filterCategory = categoryData.find(cat => cat.text === categoryValue);
      //   form.campaigncategory = filterCategory.id
      //   form.subCampaigncategory = ""
      //   this.setState({ form })
      //   this.subCategoryApiFunction(filterCategory.id)
      // }

      // if (name === "subCampaigncategory") {
      //   form.subCampaigncategory = value;
      //   this.setState({ form });
      // }

      if (name === "campaigncategory") {
        const categoryValue = value;
        const filterCategory = categoryData.find(cat => cat.text === categoryValue);
        form.campaigncategory = filterCategory.id;
        form.subCampaigncategory = "";
        this.subCategoryApiFunction(filterCategory.id);
      } else if (name === "subCampaigncategory") {
        form.subCampaigncategory = value;
      }

      if (name === "primaryGoal") {
        const primaryGoalValue = value;
        const filterPrimaryGoal = primaryGoalData.filter(goal => {
          return goal.value === primaryGoalValue
        })

        if (filterPrimaryGoal.length > 0) {
          filterPrimaryGoal.map(data => {
            this.setState({ primaryGoalId: data.id })
            this.secondaryApiFunction(data.id)
          })
        }
        form.secondryGoal = ''
        this.setState({ form })
      }

      if (name === "secondryGoal") {
        const secondaryGoalValue = value;
        const filterSecondaryGoal = secondaryGoalData.filter(goal => {
          return goal.value === secondaryGoalValue
        })

        if (filterSecondaryGoal.length > 0) {
          filterSecondaryGoal.map(secData => {
            this.setState({ secondaryGoalId: secData.id })
          })
        }
      }



    });

  };


  handleTouch = (e) => {
    let { touched, form, errors } = this.state;
    let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
    errors[e.target.name] = error;
    touched[e.target.name] = true;
    this.setState({ touched, errors });
  };

  toggleModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
  };

  confirmationCallBack = (success, info) => {
    const { confirmationOpen } = this.state;
    if (success && info.action.type === 'Confirmation') {
      this.createMapRO();
    } else if (info.action.type === 'alert') {
      this.setState({ confirmationOpen: !confirmationOpen }, () => {
        const { history } = this.props;
        history.push('/' + routes.mainRoute + '/' + routes.containers.unmappedCampaign);
      });
      return;
    } else if (info.action.type === 'Success') {
      this.setState({ confirmationOpen: !confirmationOpen }, () => {
        const { history } = this.props;
        history.push('/' + routes.mainRoute + '/' + routes.containers.unmappedCampaign);
      });
      return;
    }
    this.setState({ confirmationOpen: false });
  };

  // // ========== fetch category ===========
  // categoryApiFunction = async () => {
  //   const { tenantId, authToken, userId, getCategoryAction, configurationList, ioAdvertisersReport } = this.props;
  //   const {
  //     responseCode: { status = "" },
  //     responseList,
  //   } = await getCategoryAction({ tenantId, authToken, userId });
  //   if (status == "success") {
  //     const categoryListDropdownData = responseList.map((item, index) => {
  //       return { text: item.value, id: item.id };
  //     });
  //     this.setState({ categoryData: categoryListDropdownData });
  //   }
  // }



  categoryApiFunction = async () => {
    const { tenantId, authToken, userId, getCategoryAction, configurationList } = this.props;
    const { form, errors } = initializeForm(formFields);
    const {
      responseCode: { status = "" },
      responseList,
    } = await getCategoryAction({ tenantId, authToken, userId });
    if (status == "success") {
      const categoryListDropdownData = responseList.map((item, index) => {
        return { text: item.value, id: item.id };
      });
      if (categoryListDropdownData.length == 1)
      {
        this.setState(prevState => ({
          form: {
            ...prevState.form,
            campaigncategory: categoryListDropdownData[0].id,
          },
        }),()=>{
          this.subCategoryApiFunction( categoryListDropdownData[0].id,);
          
        });

      }
      this.setState(prevState => ({
        categoryData: categoryListDropdownData,
      }));
    }
  }

  // ================= fetch sub-category by id ============== 
  // subCategoryApiFunction = async (cateID) => {
  //   const { tenantId, authToken, userId, getSUbCategoryAction, configurationList } = this.props;
  //   const {
  //     responseCode: { status = "" },
  //     responseList,
  //   } = await getSUbCategoryAction({ tenantId, authToken, cateID, userId });
  //   if (status == "success") {
  //     const subCategoryListDropdownData = responseList.map((item, index) => {
  //       return { text: item.value, categoryID: item.id };
  //     });
  //     this.setState({ subCategoryData: subCategoryListDropdownData });
  //   }
  // }


  subCategoryApiFunction = async (cateID) => {
    const { tenantId, authToken, userId, getSUbCategoryAction, configurationList } = this.props;
    const {
      responseCode: { status = "" },
      responseList,
    } = await getSUbCategoryAction({ tenantId, authToken, cateID, userId });
    
    if (status === "success") {
      const subCategoryListDropdownData = responseList.map((item, index) => {
        return { text: item.value, categoryID: item.id };
      });
      
      if (subCategoryListDropdownData.length == 1) {
        const firstSubCategory = subCategoryListDropdownData[0].text;
        this.setState(prevState => ({
          form: {
            ...prevState.form,
            subCampaigncategory: firstSubCategory,
          },
          subCategoryData: subCategoryListDropdownData,
        }));
      } else {
        this.setState({
          subCategoryData: subCategoryListDropdownData,
        });
      }
    }
  };

  // =============== fetch primary goals ==============

  // primaryGoalApiFunction = async () => {
  //   const { tenantId, authToken, userId, getPrimaryGoalAction, configurationList } = this.props;
  //   const {
  //     responseCode: { status = "" },
  //     responseList,
  //   } = await getPrimaryGoalAction({ tenantId, authToken, userId });
  //   if (status == "success") {
  //     // console.log("responseList", responseList);
  //     this.setState({ primaryGoalData: responseList });
  //   }
  // }

  // // ================= fetch secondary-goals by id ==============
  // secondaryApiFunction = async (primaryGoalID) => {
  //   const { tenantId, authToken, userId, getSecondaryGoalAction, configurationList } = this.props;
  //   const {
  //     responseCode: { status = "" },
  //     responseList,
  //   } = await getSecondaryGoalAction({ tenantId, authToken, primaryGoalID, userId });
  //   if (status == "success") {
  //     this.setState({ secondaryGoalData: responseList });
  //   }
  // }

  primaryGoalApiFunction = async () => {
    const { tenantId, authToken, userId, getPrimaryGoalAction, configurationList } = this.props;
    const {
      responseCode: { status = "" },
      responseList,
    } = await getPrimaryGoalAction({ tenantId, authToken, userId });
    
    if (status === "success") {
      if (responseList.length == 1) {
        this.setState(prevState => ({
          form: {
            ...prevState.form,
            primaryGoal: responseList[0].value,
          },
          primaryGoalData: responseList,
        }), () => {
          // Call secondaryApiFunction with the first primary goal ID after setting primaryGoalData
          this.secondaryApiFunction(responseList[0].id);
        });
      }
      else {
        this.setState({
          primaryGoalData: responseList,
        });
      }
    }
  };
  

  // ================= fetch secondary-goals by id ==============
  // secondaryApiFunction = async (primaryGoalID) => {
  //   const { tenantId, authToken, userId, getSecondaryGoalAction, configurationList } = this.props;
  //   const {
  //     responseCode: { status = "" },
  //     responseList,
  //   } = await getSecondaryGoalAction({ tenantId, authToken, primaryGoalID, userId });
  //   if (status == "success") {
  //     if (responseList.length > 0){
  //       this.setState(prevState => ({
  //         form: {
  //           ...prevState.form,
  //           secondaryGoal: responseList[0].value,
  //         },
  //       }));
  //     }
  //     this.setState({ secondaryGoalData: responseList });
  //   }

  // }


  secondaryApiFunction = async (primaryGoalID) => {
    const { tenantId, authToken, userId, getSecondaryGoalAction, configurationList } = this.props;
    const {
      responseCode: { status = "" },
      responseList,
    } = await getSecondaryGoalAction({ tenantId, authToken, primaryGoalID, userId });
    
    if (status === "success") {
      if (responseList.length == 1) {
        this.setState(prevState => ({
          form: {
            ...prevState.form,
            secondryGoal: responseList[0].value,
          },
          secondaryGoalData: responseList,
        }));
      }
      else {
        this.setState({
          secondaryGoalData: responseList,
        });
      }
    }
  };

  reset = () => {
    return {
      advertiserId: '',
      brief: '',
      startDate: '',
      endDate: '',
      name: '',
      // budget: '',
      currency: '',
    };
  };

  toast = (status, msg) => {
    this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
    return;
  }


  // ======== create RO =========
  createMapRO = async () => {
    const { form, roForm, primaryGoalId, secondaryGoalId, unmappedDataList, subCategoryData } = this.state;
    const { ioAdvertisersReport } = this.props;

    const advertiserId = ioAdvertisersReport.find(item => item.key == form.advertiserId);

    if (unmappedDataList != undefined && unmappedDataList.length > 0) {
      var unmmppedFinalArr = [];
      unmappedDataList.forEach(unmapped => {
        let obj = {
          campaignId: unmapped.campaignId,
          name: unmapped.name,
          url: unmapped.url
        }
        unmmppedFinalArr.push(obj);
      })
    }

    const subCategory = form.subCampaigncategory;
    const findSubCat = subCategoryData.find(item => item.text == subCategory);

    const payload = {
      Ro: {
        id: +advertiserId.key,
        name: form.roName,
        categoryId: form.campaigncategory,
        subCategoryId: findSubCat.categoryID,
        // totalBudget: +form.budget,
        status: form.status === 'Inactive' ? 0 : 1,
        sDate: moment(roForm.sdate).format("YYYY-MM-DD"),
        eDate: moment(roForm.edate).format("YYYY-MM-DD"),
        goalValue: {
          primaryGoal: {
            id: primaryGoalId,
            value: form.primaryGoal,
            targetValue: +form.targetValuePrimary,
            tolerance: +form.tolerancePrimary,
          },
          secondaryGoal: {
            id: secondaryGoalId,
            value: form.secondryGoal,
            targetValue: +form.targetValueSecondry,
            tolerance: +form.toleranceSecondry
          }
        },
        unmappedCampaign: unmmppedFinalArr
      }
    };


    const { tenantId, authToken, userId, createMapRoAction, history, match } =
      this.props;

    const {
      responseCode: { status = "", msg = "" },
      // responseList,
    } = await createMapRoAction({
      tenantId,
      authToken,
      userId,
      payload
    });

    const successfullyMessage = {
      action: {
        confirmationMessage: msg,
        type: 'Success',
      }
    }

    if (status) {
      this.toast(status, msg);
    }
  }

  handleToastStatus = (status) => {
    this.setState({ enableToast: status });
  }

  // ====== delete campaign =========


  deleteAlert = (campaignId) => {
    this.setState({ enableToast: true, confirmationMsg: "Are You Sure To Delete?", poc: true, method: "delete", DeleteID: campaignId });
  }
  deleteCampaign = (campaignId) => {
    const { unmappedDataList } = this.state;
    let status = "Success"
    let msg
    if (status) {
      this.toast(status, msg = "Successfully Deleted")
      var mappedCampaignsFilter = unmappedDataList.filter(x => {
        return x.campaignId != campaignId;
      })

      this.setState({ unmappedDataList: mappedCampaignsFilter })
    }
  }

  toggleAlertModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation })
  }

  filesUpload = async (e, index) => {
    const urlName = e.target.name;
    let { uploadFileAction, ioAdvertisersReport } = this.props;
    const { form, unmappedDataList } = this.state;
    const data = new FormData();

    const blob = e.target.files[0];

    data.append('file', blob, blob.name);

    const response = await uploadFileAction(data, form.advertiserId, 'image');
    if (response && response.responseCode && response.responseCode.status === 'Success') {
      const list = [...unmappedDataList];
      list[index][urlName] = response.responseList;

      this.setState({ unmappedDataList: list });
    } else {
      let info = { action: { confirmationMessage: response.responseCode.desc, type: 'error' } }
      this.toggleAlertModal(info);
    }
  }

  deleteFile = (index) => {
    const { unmappedDataList } = this.state;
    const list = [...unmappedDataList];
    list[index]["url"] = "";
    this.setState({ unmappedDataList: list });
  }

  handleApply = async () => {
    const { form } = this.state;
    let { errors, valid } = handleError(form, formFields);
    let isValidList = true;
    if (valid) {
      this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes.", poc: false, method: "save" });
    } else {
      // let require = { action: { confirmationMessage: 'All Fields Are Required', type: 'error' } };
      // this.toggleModal(require);
      this.setState({ enableToast: true, toastMsg: "All Fields are Required", toastStatus: "Fail" });
      this.setState({ errors: errors, submited: true });
    }
  }




  confirmationCallbackModel = (id) => {
    const { method, DeleteID } = this.state
    this.setState({ enableToast: false }, () => {
      if (method == "delete") {
        this.deleteCampaign(DeleteID)

      } else if (method == "save") {

        this.createMapRO();
      }
    });

  }

  handleToastStatus = (status) => {
    console.log(status, "sta")
    this.setState({ enableToast: status, toastStatus: "", toastMsg: "" });
  }

  render() {
    const maxDate = new Date();
    const { confirmationOpen, confirmationInfo, submited, errors, touched, form, editMode, roForm, categoryData, confirmationMsg, subCategoryData, primaryGoalData, secondaryGoalData, roListNames, unmappedDataList, toastMsg, toastStatus, enableToast, poc } = this.state;
    const { ioAdvertisersReport, match: { params: { id } }, match, advertiserList, tenantId } = this.props;
    var filteredAdvertiser = advertiserList.filter(adv => adv.tenantId === tenantId);
    var advertiserData = filteredAdvertiser.map(item => { return { key: item.tenantId, value: item.tenantName } })
    // console.log("form",form)

    return (
      <>
        {confirmationOpen && (<ModalConfirmation
          open={confirmationOpen}
          onClose={this.toggleModal}
          confirmationInfo={confirmationInfo}
          handelConfirmationMessage={this.confirmationCallBack}
        />)}

        {
          enableToast && <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            path={routes.containers.unmappedCampaign}
            idProps={this.props}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
            poc={poc}

          />
        }

        <div className="main-panel ion">
          <div className="content-wrapper">
            <BreadCrumb />
            <div className="row justify-content-center mt-3">
              <div className="col-md-12 grid-margin">
                <Card>
                  <div className='row'>
                    <div className="col-md-6">
                      <div className='custom-test-select'>
                        <label for="cars">Advertiser <span className='text-danger'>*</span></label>
                        <select 
                        disabled={advertiserData.length == 1} 
                        name="advertiserId" defaultValue={advertiserData[0].value} onBlur={this.handleTouch} onChange={this.handleChange} className={`${advertiserData.length === 1 ? 'bg-secondary' : ''} ${errors.advertiserId.required ? 'has-error' : ''}`}
                        >
                          <option value="Select" >Select</option>
                          {
                            advertiserData.map(option =>
                              <option value={option.value}>{option.value}</option>
                            )
                          }
                        </select>
                        <span className='error-message'>{errors.advertiserId.required ? "This Field is required" : ""}</span>
                      </div>
                    </div>
                    <div className="col-md-6 ">
                      <Input
                        onChange={this.handleChange}
                        onBlur={this.handleTouch}
                        value={form[formFields.roName.key]}
                        setting={formFields[formFields.roName.key]}
                        error={errors[formFields.roName.key]}
                        submited={submited}
                        touched={touched[formFields.roName.key]}
                      />
                    </div>

                    <div className="col-md-6">
                      {
                        form[formFields.campaigncategory.key] ?
                          <div className='custom-test-select new'>
                            <label for="cars">Category <span className='text-danger'>*</span></label>
                            <select name="campaigncategory" onChange={this.handleChange} onBlur={this.handleTouch}>
                              <option value="Select" disabled>Select</option>
                              {
                                categoryData.map(option => option.id === form[formFields.campaigncategory.key] ?
                                  <option value={option.text} selected>{option.text}</option> : <option value={option.text}>{option.text}</option>
                                )
                              }
                            </select>
                          </div>
                          : <div className='custom-test-select'>
                            <label for="cars">Category <span className='text-danger'>*</span></label>
                            <select name="campaigncategory" onChange={this.handleChange} onBlur={this.handleTouch} className={errors.campaigncategory.required ? "has-error" : ""}>
                              <option value="Select">Select</option>
                              {
                                categoryData.map(option =>
                                  <option value={option.text}>{option.text}</option>
                                )
                              }
                            </select>
                            <span className='error-message'>{errors.campaigncategory.required ? "This Field is required" : ""}</span>
                          </div>
                      }
                    </div>
                    {/* <div className="col-md-6 ">

                      {
                        form[formFields.subCampaigncategory.key] ?
                          <div className='custom-test-select new'>
                            <label for="cars">Sub-Category <span className='text-danger'>*</span></label>
                            <select name="subCampaigncategory" onChange={this.handleChange} onBlur={this.handleTouch} value={form[formFields.subCampaigncategory.key]}>
                              <option value="" disabled>Select</option>
                              {
                                subCategoryData.map(option => option.categoryID === form[formFields.subCampaigncategory.key] ?
                                  <option value={option.text} selected>{option.text}</option> : <option value={option.text}>{option.text}</option>

                                )
                              }
                            </select>
                          </div> : <div className='custom-test-select'>
                            <label for="cars">Sub-Category <span className='text-danger'>*</span></label>
                            <select name="subCampaigncategory" value={form[formFields.subCampaigncategory.key]} onChange={this.handleChange} onBlur={this.handleTouch} className={errors.subCampaigncategory.required ? "has-error" : ""}>
                              <option value="">Select</option>
                              {
                                subCategoryData != undefined && subCategoryData.map(option =>
                                  <option value={option.text}>{option.text}</option>
                                )
                              }
                            </select>
                            <span className='error-message'>{errors.subCampaigncategory.required ? "This Field is required" : ""}</span>

                          </div>
                      }
                    </div> */}

                    <div className="col-md-6 ">
                        <div className='custom-test-select new'>
                        <label htmlFor="cars">Sub-Category <span className='text-danger'>*</span></label>
                        <select name="subCampaigncategory" onChange={this.handleChange} value={form[formFields.subCampaigncategory.key]}  onBlur={this.handleTouch} className={errors.subCampaigncategory.required ? "has-error" : ""} >
                          <option value="" disabled>Select</option>
                          {subCategoryData && subCategoryData.map(option => (
                            <option key={option.categoryID} value={option.text} selected={form[formFields.subCampaigncategory.key] === option.text}>
                              {option.text}
                            </option>
                          ))}
                        </select>
                        <span className='error-message'>{errors.subCampaigncategory.required ? "This Field is required" : ""}</span>

                      </div>
                    </div>

                    <div className='row col-md-12  mb-3'>
                      <div className="col-md-4 mt-3">

                        {/* {
                          form[formFields.primaryGoal.key] ?
                            <div className='custom-test-select new'>
                              <label for="cars" className='mb-2'>Primary Goal <span className='text-danger'>*</span></label>
                              <select name="primaryGoal" onChange={this.handleChange} onBlur={this.handleTouch}>
                                <option value="Select" disabled>Select</option>
                                {
                                  primaryGoalData.map(option => option.id === form[formFields.primaryGoal.key] ?
                                    <option value={option.value} selected>{option.value}</option> : <option value={option.value}>{option.value}</option>

                                  )
                                }
                              </select>
                            </div> : <div className='custom-test-select'>
                              <label for="cars" className='mb-2'>Primary Goal <span className='text-danger'>*</span></label>
                              <select name="primaryGoal" onChange={this.handleChange} onBlur={this.handleTouch} className={errors.primaryGoal.required ? "has-error" : ""}>
                                <option value="Select">Select</option>
                                {
                                  primaryGoalData != undefined && primaryGoalData.map(option =>
                                    <option value={option.value}>{option.value}</option>
                                  )
                                }
                              </select>
                              <span className='error-message'>{errors.primaryGoal.required ? "This Field is required" : ""}</span>

                            </div>
                        } */}


                        
                      <div className='custom-test-select new'>
                        <label htmlFor="cars" className='my-2'>Primary Goal <span className='text-danger'>*</span></label>
                        <select name="primaryGoal" onChange={this.handleChange} onBlur={this.handleTouch} className={errors.primaryGoal.required ? "has-error" : ""} value={form[formFields.primaryGoal.key]}>
                          <option value="" disabled>Select</option>
                          {
                            primaryGoalData.map(option => (
                              <option key={option.id} value={option.value}>
                                {option.value}
                              </option>
                            ))
                          }
                        </select>
                        <span className='error-message'>{errors.primaryGoal.required ? "This Field is required" : ""}</span>

                      </div>
                      </div>
                      <div className="col-md-4 mt-3">
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFields.targetValuePrimary.key]}
                          setting={formFields[formFields.targetValuePrimary.key]}
                          error={errors[formFields.targetValuePrimary.key]}
                          submited={submited}
                          touched={touched[formFields.targetValuePrimary.key]}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFields.tolerancePrimary.key]}
                          setting={formFields[formFields.tolerancePrimary.key]}
                          error={errors[formFields.tolerancePrimary.key]}
                          submited={submited}
                          touched={touched[formFields.tolerancePrimary.key]}
                        />
                      </div>

                      <div className="col-md-4 mt-2">
                        {
                          form[formFields.secondryGoal.key] ?
                            <div className='custom-test-select new'>
                              <label for="cars" className='mb-2'>Secondary Goal <span className='text-danger'>*</span></label>
                              <select name="secondryGoal" onChange={this.handleChange} onBlur={this.handleTouch} value={form[formFields.secondryGoal.key]}>
                                <option value="" disabled>Select</option>
                                {
                                  secondaryGoalData.length > 0 && secondaryGoalData.map(option => option.id === form[formFields.secondryGoal.key] ?
                                    <option value={option.id} selected>{option.value}</option> : <option value={option.value}>{option.value}</option>
                                  )
                                }
                              </select>
                            </div> : <div className='custom-test-select'>
                              <label for="cars" className='mb-2'>Secondary Goal <span className='text-danger'>*</span></label>
                              <select name="secondryGoal" value={form[formFields.secondryGoal.key]} onChange={this.handleChange} onBlur={this.handleTouch} className={errors.secondryGoal.required ? "has-error" : ""}>
                                <option value="">Select</option>
                                {
                                  secondaryGoalData != undefined && secondaryGoalData.map(option =>
                                    <option value={option.value}>{option.value}</option>
                                  )
                                }
                              </select>
                              <span className='error-message'>{errors.secondryGoal.required ? "This Field is required" : ""}</span>
                            </div>
                        }
                      </div>
                      <div className="col-md-4">
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFields.targetValueSecondry.key]}
                          setting={formFields[formFields.targetValueSecondry.key]}
                          error={errors[formFields.targetValueSecondry.key]}
                          submited={submited}
                          touched={touched[formFields.targetValueSecondry.key]}
                        />
                      </div>
                      <div className="col-md-4">
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFields.toleranceSecondry.key]}
                          setting={formFields[formFields.toleranceSecondry.key]}
                          error={errors[formFields.toleranceSecondry.key]}
                          submited={submited}
                          touched={touched[formFields.toleranceSecondry.key]}
                        />
                      </div>
                    </div>

                    {/* <div className="col-md-4 ">
                      <Input
                        onChange={this.handleChange}
                        onBlur={this.handleTouch}
                        value={form[formFields.budget.key]}
                        setting={formFields[formFields.budget.key]}
                        error={errors[formFields.budget.key]}
                        submited={submited}
                        touched={touched[formFields.budget.key]}
                      />
                    </div> */}

                  <div className="col-md-4 mt-n1">
                      {
                        form[formFields.status.key] != "" ?
                          <Select
                            onChange={this.handleChange}
                            onBlur={this.handleTouch}
                            value={form[formFields.status.key]}
                            setting={formFields[formFields.status.key]}
                            // error={errors[formFields.status.key]}
                            submited={submited}
                            touched={touched[formFields.status.key]}
                            options={sortArray(roStaus)}
                          /> :
                          <div className='custom-test-select'>
                            <label for="cars">Status <span className='text-danger'>*</span></label>
                            <select name='status' defaultValue={roStaus[0].value} onChange={this.handleChange} onBlur={this.handleTouch} className={errors.status.required ? "has-error" : ""}>
                              <option value="Select">Select</option>
                              {
                                roStaus.map(option =>
                                  <option value={option.value}>{option.value}</option>
                                )
                              }
                            </select>
                            <span className='error-message'>{errors.status.required ? "This Field is required" : ""}</span>
                          </div>

                      }

                    </div>


                    <div className=" row col-md-8" id="TrendsDateElement">
                      {/* <div className="row"> */}
                      {/* <div className="col-md-5"> */}
                      <div className='col-md-6'>
                        <label style={{ fontSize: '14px' }}>Start Date</label>
                        <DatePicker
                          value={roForm.sdate}
                          onChange={(date) => {
                            this.setState({
                              ...this.state,
                              roForm: {
                                ...this.state.roForm,
                                sdate: date,
                              },
                            });
                          }}
                          name="startDate"
                          // maxDate={maxDate}
                          minDate={new Date()}
                          maxDate={roForm.edate}
                          placeholderText="Start Date"
                        />
                      </div>
                      {/* </div> */}

                      <div className="col-md-6">
                        {/* <div> */}
                        <label style={{ fontSize: '14px' }}>End Date</label>
                        <DatePicker
                          value={roForm.edate}
                          onChange={(date) => {
                            this.setState({
                              ...this.state,
                              roForm: {
                                ...this.state.roForm,
                                edate: date,
                              },
                            });
                          }}
                          name="endDate"
                          minDate={roForm.sdate}
                          // maxDate={maxDate}
                          placeholderText="End Date"
                        />

                      </div>
                      {/* </div> */}
                      {/* </div> */}
                    </div>


                    {
                      unmappedDataList.length > 0 && (
                        <div className="col-md-12 p-0 btn-block text-left mt-4 badgeText">
                          <p style={{ fontSize: '14px' }}>Campaign DSP Mapping</p>
                        </div>
                      )
                    }
                    {
                      unmappedDataList != undefined && unmappedDataList.length > 0 && unmappedDataList.map((e, index) => (
                        <div className='row w-100 mt-3'>
                          <div className='col-md-4 mt-3 unmappedCamp'>
                            <label>Platform</label>
                            <input type='text' className='form-control' value={e.platform} disabled />
                          </div>
                          <div className='col-md-4 mt-3 unmappedCamp'>
                            <label>Campaign Name</label>
                            <input type='text' className='form-control' value={e.name} disabled />
                          </div>
                          <div className='col-md-3 mt-3'>
                            <label htmlFor="getUpload" className="col-sm-12 col-form-label" style={{ fontSize: '13px', padding: "10px 0px" }}>Dashboard Thumbnail</label>
                            {
                              e.url != '' ? <div className='mappedImg'><img src={e.url} />
                                <button onClick={() => this.deleteFile(index)}>
                                  <i className="mdi mdi-close text-dark"></i>
                                </button>
                              </div> :
                                <div className="">
                                  <input name="url" accept="image/*"
                                    onChange={(e) => this.filesUpload(e, index)} type="file" />
                                </div>
                            }

                          </div>
                          {
                            unmappedDataList.length > 1 ?
                              <div className='col-md-1 mt-3 flexClass align-items-end pb-2'>
                                <button className="btn-remove"  onClick={() => this.deleteAlert(e.campaignId)}  ><i className='mdi mdi-delete'></i></button>
                              </div>
                              : ""
                          }
                        </div>

                      ))
                    }
                    <div className="form-group row mt-5" style={{ width: "100%" }}>
                      <div className="col-sm-12">
                        <center>

                          <button type="submit" onClick={() => this.handleApply()} className="btn btn-primary">Save RO</button>
                          <Link to={'/' + routes.mainRoute + '/' + routes.containers.unmappedCampaign}><button type="button" className="btn btn-secondary ml-2">Cancel</button></Link>
                        </center>
                      </div>
                    </div>
                  </div>

                </Card>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(
  state => ({
    configurationList: get(state, 'app.configurationData.responseList', []),
    ioAdvertisersReport: get(state, 'app.ioAdvertisersReport.responseList', []),
    tenantId: get(state, 'app.preSignInState.tenantId', ''),
    userId: get(state, 'app.preSignInData.userId', ''),
    authToken: get(state, 'app.signInData.authToken', ''),
    advertiserList: get(state, 'app.preSignInData.responseList')
  }),
  {
    addIoReportAction,
    getIoAdvertisersReportAction,
    getIoEditIdReportAction,
    getCategoryAction,
    getSUbCategoryAction,
    getPrimaryGoalAction,
    getSecondaryGoalAction,
    createMapRoAction,
    // getRoListByIdAction,
    // updateRoAction,
    uploadFileAction,
    getUnmappedCampaignListAction,
    roListNamesAction
  }
)(AddRo);

// ----*  IO propTypes * ----
AddRo.propTypes = {
  addIoReportAction: PropTypes.func,
  getIoAdvertisersReportAction: PropTypes.func,
  configurationList: PropTypes.array,
  ioAdvertisersReport: PropTypes.array,
};